import React from 'react';
import styled from 'styled-components';
import { WorkFilterData } from '../../shared/dto/EntityRepository';
import { DeviceType, MemberType } from '../../shared/enum/EnumRepository';
import { UniversalCheckbox } from '../../shared/component/UniversalCheckbox';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { useMemberCreditStore } from '../../shared/store/memberCreditStore';
import { useSettingStore } from '../../shared/store/settingStore';
import { WorkImportSubTitle } from './FilterStationWorkType';

interface FilterStationMemberCreditProps {
  currentFilter: WorkFilterData;
  setCurrentFilter: (filter: WorkFilterData) => void;
}

const FilterStationMemberCredit: React.FC<FilterStationMemberCreditProps> = ({
  currentFilter,
  setCurrentFilter,
}) => {
  const setting = useSettingStore((s) => s.setting);
  const credits = useMemberCreditStore((s) => s.credits);
  const deviceType = useDeviceStore((s) => s.deviceType);
  const [memberAll, setMemberAll] = React.useState(
    (currentFilter.creditIds ?? []).length === 0,
  );

  if (setting?.memberType !== MemberType.GROUP || credits.length === 0) {
    return null;
  }

  const selectedCreditIds = memberAll
    ? credits.map((credit) => credit.id)
    : currentFilter.creditIds ?? [];

  const handleMemberChange = (creditId: number) => {
    const nextCreditIds = selectedCreditIds.includes(creditId)
      ? selectedCreditIds.filter((id) => id !== creditId)
      : [...selectedCreditIds, creditId];
    const nextMemberAll = nextCreditIds.length === credits.length;
    setMemberAll(nextMemberAll);
    setCurrentFilter({
      ...currentFilter,
      creditIds: nextMemberAll ? [] : nextCreditIds,
    });
  };

  const handleMemberChangeAll = () => {
    const nextMemberAll = !memberAll;
    setMemberAll(nextMemberAll);
    setCurrentFilter({
      ...currentFilter,
      creditIds: [],
    });
  };

  return (
    <MemberFilterComp>
      <WorkImportSubTitle $isMobile={deviceType === DeviceType.MOBILE}>
        Member
      </WorkImportSubTitle>
      <MemberFilterList $isMobile={deviceType === DeviceType.MOBILE}>
        {credits.map((credit) => (
          <CheckboxComp key={credit.id}>
            <UniversalCheckbox
              checked={selectedCreditIds.includes(credit.id)}
              onChange={() => handleMemberChange(credit.id)}
            />
            {credit.name}
          </CheckboxComp>
        ))}
        <CheckboxComp>
          <UniversalCheckbox
            checked={memberAll}
            onChange={handleMemberChangeAll}
          />
          Select ALL
        </CheckboxComp>
      </MemberFilterList>
    </MemberFilterComp>
  );
};

export default FilterStationMemberCredit;

const MemberFilterComp = styled.div`
  display: flex;
  flex-direction: column;
`;

const MemberFilterList = styled.div<{ $isMobile: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: ${({ $isMobile }) => ($isMobile ? '2vw' : '20px')};
  row-gap: ${({ $isMobile }) => ($isMobile ? '1vh' : '4px')};
`;

const CheckboxComp = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
  user-select: none;
  cursor: pointer;
`;
